import classNames from 'classnames/bind';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const domRefs = useRef({
    timeout: useRef(),
    minAlt: useRef(),
    maxAlt: useRef(),
    horizMoveLimit: useRef(),
  }).current;

  useEffect(() => {
    domRefs.timeout.current.value = command.data.timeout.toFixed(1);
    domRefs.minAlt.current.value = command.data.minAlt.toFixed(1);
    domRefs.maxAlt.current.value = command.data.maxAlt.toFixed(1);
    domRefs.horizMoveLimit.current.value = command.data.horizMoveLimit.toFixed(1);
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    let value = Number(e.target.value);

    // Timeout, Horizontal Move Limit 변경된 경우
    if (['timeout', 'horizMoveLimit'].includes(name)) {
      value = Math.max(0, value);
    }

    dispatch(actions.mission.updateCommand(index, name, value));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Timeout" unit="secs">
        <FieldNumber ref={domRefs.timeout} name="timeout" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Min Relative Altitude" unit="m">
        <FieldNumber ref={domRefs.minAlt} name="minAlt" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Max Relative Altitude" unit="m">
        <FieldNumber ref={domRefs.maxAlt} name="maxAlt" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Horizontal Move Limit" unit="m">
        <FieldNumber ref={domRefs.horizMoveLimit} name="horizMoveLimit" onBlur={handleBlur} />
      </FieldRow>
    </div>
  );
};

export default Command;
